module.exports = __webpack_public_path__ + "img/franciscobeltrao.458f6ca9.png";